// namespace
export const STORE_NAMESPACE = 'recruiters_fees'

// actions
export const FETCH_ALL = 'fetchAll'

// mutations
export const SET_RECRUITERS_FEES_LIST = 'SET_RECRUITERS_FEES_LIST'

// getters
